export const GET_QUEUE_POSITIONS = 'GET_QUEUE_POSITIONS';
export const GET_QUEUE_POSITIONS_SUCCESS = 'GET_QUEUE_POSITIONS_SUCCESS';
export const GET_QUEUE_POSITIONS_ERROR = 'GET_QUEUE_POSITIONS_ERROR';
